import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment-jalaali';
import { api } from '../services';
import { payApi } from '../services/payApi';
import { Button, Spinner } from 'react-bootstrap';
import { formatNumberWithPersianSeparators } from '../utils/formatNumber';

// Unified debug flow component: Reserve (SabtNobat) -> Verify -> Show Receipt
const PaymentDebugFlow = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [step, setStep] = useState('init'); // init | reserving | verifying | receipt | error
  const [error, setError] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [serviceCategoryId, setServiceCategoryId] = useState(localStorage.getItem('ServiceCategoryID') || null);
  const [sabtNobatUrl, setSabtNobatUrl] = useState(null);
  const [logs, setLogs] = useState([]);
  const isMountedRef = useRef(true);
    const [, setShowModal] = useState(false);
    const [, setModalMessage] = useState('');
      const [, setIsError] = useState(false);
      const [profile, setProfile] = useState(null);

  const key = useMemo(() => localStorage.getItem('key'), []);
  const OID = useMemo(() => (process.env.REACT_APP_OID || '1'), []);

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const authorityFromUrl = searchParams.get('Authority') || searchParams.get('authority');
  const statusFromUrl = searchParams.get('Status') || searchParams.get('status');
  const descParam = searchParams.get('desc') || searchParams.get('Desc');

  const addLog = useCallback((entry) => {
    setLogs((prev) => [
      ...prev,
      {
        timestamp: new Date().toISOString(),
        ...entry,
      },
    ]);
  }, []);
 const baseUrlCRM = process.env.REACT_APP_CRMFILE_SERVER;
   //برای ثبت درخواست این توابع اضافه شده 
          const fetchProfile = async () => {
            try {
              const response = await api.get(`Home/GetProfileInfo?SesID=${key}&OID=${OID}`);
              let data = response.data;
      
              if (typeof data === 'string') {
                try {
                  data = JSON.parse(data);
                } catch (error) {
                  console.error('Invalid JSON string:', data);
                  
                  return;
                }
              }
      
              if (Array.isArray(data) && data.length > 0) {
                localStorage.setItem('patientID', data[0].PatientID);
                if (!data[0].Melicode) {
                  navigate('/edirPro');
                }
                return data;
                
              } else {
                 console.error('اطلاعات پروفایل یافت نشد');
               
              }
            } catch (error) {
              console.error('Error fetching profile:', error);
            
            }
          };
  
    const searchPatient = async (mobile) => {
      try {
        const response = await fetch(
          `${baseUrlCRM}api/doapi?apikey=${process.env.REACT_APP_API_KEY}&func=SearchBimar&Mobile=${mobile}`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          }
        );
  
        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (error) {
          console.error('Invalid JSON response from SearchBimar:', text);
          throw new Error('پاسخ سرور نامعتبر است');
        }
  
        return data;
      } catch (error) {
        console.error('Error searching patient:', error);
        throw error;
      }
    };

    const GetVaziatByCode = async (code) => {
      try {
        const response = await fetch(
          `${baseUrlCRM}api/doapi?apikey=${process.env.REACT_APP_API_KEY}&func=GetVaziatByCode&vcode=${code}`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          }
        );
  
        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (error) {
          console.error('Invalid JSON response from SearchBimar:', text);
          throw new Error('پاسخ سرور نامعتبر است');
        }
  
        return data;
      } catch (error) {
        console.error('Error searching patient:', error);
        throw error;
      }
    };

  
    const insertPatient = async (profile) => {
      try {
        const params = new URLSearchParams({
          apikey: process.env.REACT_APP_API_KEY,
          func: 'InsertBimar',
          userid: '6',
          Fname: profile.Fname,
          Lname: profile.Lname,
          CodeMelli: profile.Melicode || '',
          FileNo: profile.PatientFileNo.toString(),
          Mobile: profile.Mobile,
          FatherName: '-',
        });
  
        const response = await fetch(
          `${baseUrlCRM}api/Doupdateapi?${params.toString()}`,
          {
            method: 'GET',
          }
        );
  
        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (error) {
          console.error('Invalid JSON response from InsertBimar:', text);
          throw new Error('پاسخ سرور نامعتبر است');
        }
  
        if (data && data.id) {
          return data.id;
        } else {
          throw new Error('ثبت بیمار ناموفق بود');
        }
      } catch (error) {
        console.error('Error inserting patient:', error);
        throw error;
      }
    };
  
    const insertRequest = async (ccid, question, description,VaziatCode) => {
      try {
         const now = moment();
                  const persianDate = now.format('jYYYY/jMM/jDD');
  
        const requestDesc = `${question}: ${description}`;
        const params = new URLSearchParams({
          apikey: process.env.REACT_APP_API_KEY,
          func: 'InsertRequest',
          userid: '36400',
          BimarID: ccid,
          SabtDate: persianDate,
          RequestDesc: requestDesc,
          Vaziat: VaziatCode
        });
  
        const response = await fetch(
          `${baseUrlCRM}api/Doupdateapi?${params.toString()}`,
          {
            method: 'GET',
          }
        );
  
        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (error) {
          console.error('Invalid JSON response from InsertRequest:', text);
          throw new Error('پاسخ سرور نامعتبر است');
        }
  
        if (data && data.id) {
          return data.id;
        } else {
          throw new Error('ثبت درخواست ناموفق بود');
        }
      } catch (error) {
        console.error('Error inserting request:', error);
        throw error;
      }
    };
    const insertRequestPayment = async (ccid, price, rahgiri,paydate,description) => {
      try {
         const now = moment();
                  const persianDate = now.format('jYYYY/jMM/jDD');
  
        const requestDesc = ` ${description}`;
        const params = new URLSearchParams({
          apikey: process.env.REACT_APP_API_KEY,
          func: 'InsertVariz',
          userid: '36400',
          pccid: ccid,
          PayDate: paydate,
          Description: requestDesc,
          Price:price,
          Rahgiri:rahgiri,

        });
  
        const response = await fetch(
          `${baseUrlCRM}api/Doupdateapi?${params.toString()}`,
          {
            method: 'GET',
          }
        );
  
        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (error) {
          console.error('Invalid JSON response from InsertRequest:', text);
          throw new Error('پاسخ سرور نامعتبر است');
        }
  
        if (data && data.id) {
          return data.id;
        } else {
          throw new Error('ثبت واریز درخواست ناموفق بود');
        }
      } catch (error) {
        console.error('Error inserting request:', error);
        throw error;
      }
    };
    //پایان توابع ثبت درخواست 
  

  const parseDescriptionFromURL = useCallback((desc) => {
    try {
      if (!desc) return null;
      const decoded = decodeURIComponent(desc);
      const fields = decoded.split(' | ');
      const parsed = {};
      fields.forEach((field) => {
        const i = field.indexOf(':');
        if (i !== -1) {
          const k = field.substring(0, i).trim();
          const v = field.substring(i + 1).trim();
          parsed[k] = v;
        }
      });
      return parsed;
    } catch (e) {
      addLog({ type: 'parse_desc_error', error: String(e) });
      return null;
    }
  }, [addLog]);

  const toHHMMSS = useCallback((time) => {
    if (!time) return '';
    const parts = String(time).split(':');
    const hour = (parts[0] || '00').padStart(2, '0');
    const minute = (parts[1] || '00').padStart(2, '0');
    const second = (parts[2] || '00').padStart(2, '0');
    return `${hour}:${minute}:${second}`;
  }, []);

  const convertToShamsi = useCallback((date) => {
    if (!date) return 'نامشخص';
    const parsed = moment(date, [
      'jYYYY/jMM/jDD',
      'YYYY/MM/DD',
      'YYYY-MM-DD',
      'MM/DD/YYYY',
    ], true);
    if (parsed.isValid()) return parsed.format('jYYYY/jMM/jDD');
    const auto = moment(date);
    return auto.isValid() ? auto.format('jYYYY/jMM/jDD') : 'نامشخص';
  }, []);

  const formatTime = useCallback((time) => {
    if (!time || typeof time !== 'string') return 'نامشخص';
    const parsed = moment(time, [
      'HH:mm',
      'jYYYY/jMM/jDD HH:mm',
      'YYYY/MM/DD HH:mm:ss',
      'MM/DD/YYYY HH:mm:ss',
    ], true);
    if (parsed.isValid()) return parsed.format('HH:mm');
    const candidate = String(time).slice(-5);
    return /^\d{2}:\d{2}$/.test(candidate) ? candidate : 'نامشخص';
  }, []);

  const fetchUserProfile = useCallback(async () => {
    const url = `Home/GetProfileInfo?SesID=${key}&OID=${OID}`;
    try {
      addLog({ type: 'request', method: 'GET', endpoint: 'Home/GetProfileInfo', url });
      const res = await api.get(url);
      let data = res.data;
      if (typeof data === 'string') data = JSON.parse(data);
      addLog({ type: 'response', endpoint: 'Home/GetProfileInfo', ok: true });
      return data;
    } catch (e) {
      addLog({ type: 'response', endpoint: 'Home/GetProfileInfo', ok: false, error: String(e) });
      throw e;
    }
  }, [OID, addLog, key]);

  const fetchDoctorService = useCallback(async (doctorId) => {
    if (!doctorId) return null;
    const url = `Home/GetServiceDoctor?OID=${OID}&doctorId=${doctorId}`;
    try {
      addLog({ type: 'request', method: 'GET', endpoint: 'Home/GetServiceDoctor', url });
      const res = await api.get(url);
      let data = res.data;
      if (typeof data === 'string') data = JSON.parse(data);
      const online = Array.isArray(data) ? data.find((d) => d.OnlineTurning === 1) : null;
      addLog({ type: 'response', endpoint: 'Home/GetServiceDoctor', ok: true });
      return online || null;
    } catch (e) {
      addLog({ type: 'response', endpoint: 'Home/GetServiceDoctor', ok: false, error: String(e) });
      return null;
    }
  }, [OID, addLog]);

  const runFlow = useCallback(async () => {
    try {
      if (!authorityFromUrl || statusFromUrl !== 'OK') {
        setError('پارامترهای پرداخت معتبر نیستند');
        navigate('/payment');
        return;
      }

      setStep('reserving');

      const parsedDesc = parseDescriptionFromURL(descParam);
      if (parsedDesc?.['Service Category ID'] && parsedDesc['Service Category ID'] !== 'Unknown') {
        setServiceCategoryId(parsedDesc['Service Category ID']);
      }

      // Collect inputs from parsed desc then fallbacks to localStorage
      let doctorId = parsedDesc?.['Doctor ID'] || localStorage.getItem('doctor_id') || null;
      if (!doctorId) {
        try {
          const apptRaw = localStorage.getItem('appointmentData');
          if (apptRaw) doctorId = JSON.parse(apptRaw)?.doctorId || doctorId;
        } catch (_) {}
      }

      const user = await fetchUserProfile();
      const service = await fetchDoctorService(doctorId);

      const dateJalali = parsedDesc?.['Appointment Date'] || localStorage.getItem('date_n');
      const timeSelected = parsedDesc?.['Appointment Time'] || localStorage.getItem('time');
      const appointmentNumber = parsedDesc?.['Appointment Number'] || localStorage.getItem('num');
      const amount = (parsedDesc?.['Amount']?.replace(' Rials', '') || localStorage.getItem('Price') || '').toString();
      const categoryName = parsedDesc?.['Appointment Type'] || localStorage.getItem('ServiceCategoryID') || '';
      const patientId = parsedDesc?.['Patient ID'] || null;

       const gregorian = moment(dateJalali, 'jYYYY/jMM/jDD').format('YYYY-MM-DD').split('-');
      const resultTime = `${gregorian[1]}/${gregorian[2]}/${gregorian[0]}`;
      const sabtdate = moment().format('MM/DD/YYYY HH:mm:ss');
       console.log(dateJalali+'&&'+timeSelected+'&&'+appointmentNumber+'&&'+service+'&&'+user);
        console.log(serviceCategoryId);
       
        console.log(user);

      if (user && user[0]  && dateJalali && timeSelected && appointmentNumber && doctorId==='-1' && serviceCategoryId==='48') {
          // جستجوی بیمار با شماره موبایل
      const temprequestid=localStorage.getItem('requestid') || '';
      if(temprequestid===''){
       const profile=await fetchProfile();
      let patientID = patientId;
      const searchResult = await searchPatient(profile[0].Mobile);
  
      if (searchResult.length === 0) {
        patientID = await insertPatient(profile[0]);
      } else if (searchResult[0].ccid) {
        patientID = searchResult[0].ccid;
      } else {
        setModalMessage('خطا در جستجوی بیمار');
        setIsError(true);
        setShowModal(true);
        
      }
      const VaziatData=await GetVaziatByCode('104');
      let vaziatccid=0;
      if(VaziatData.length>0){
          vaziatccid=VaziatData[0].ccid;
      }
      // ثبت درخواست
      const requestId = await insertRequest(patientID, '','',vaziatccid);
      localStorage.setItem("requestid",requestId);
      const varizid=await insertRequestPayment(requestId,dateJalali,authority,dateJalali,'واریز کاربر جهت مشاوره غیر حضوری');

      }
      }else{
      if (!user || !user[0] || !service || !dateJalali || !timeSelected || !appointmentNumber) {
       
        throw new Error('اطلاعات نوبت ناقص '+dateJalali+'&&'+timeSelected+'&&'+appointmentNumber+'&&'+service+'&&'+user+'&&'+categoryName+'&&'+doctorId);
      }

     

      const sabtUrl = `Home/SabtNobat?SesID=${key}&OID=${OID}&PatientID=${patientId}&ServiceDoctorID=${service?.ID}&NobatNumber=${appointmentNumber}&timadate=${toHHMMSS(timeSelected)}&Date=${resultTime}&TransactionNum=${authorityFromUrl}&sabtdate=${sabtdate}`;
      setSabtNobatUrl(sabtUrl);
      try { localStorage.setItem('lastSabtNobatUrl', sabtUrl); } catch (_) {}

      addLog({ type: 'request', method: 'GET', endpoint: 'Home/SabtNobat', url: sabtUrl, params: {
        SesID: key,
        OID,
        PatientID: patientId,
        ServiceDoctorID: service?.ID,
        NobatNumber: appointmentNumber,
        timadate: toHHMMSS(timeSelected),
        Date: resultTime,
        TransactionNum: authorityFromUrl,
        sabtdate,
      }});
      const sabtRes = await api.get(sabtUrl);
      if (sabtRes?.data?.ErrorMessage) {
        addLog({ type: 'response', endpoint: 'Home/SabtNobat', ok: false, error: sabtRes.data.ErrorMessage });
        throw new Error(sabtRes.data.ErrorMessage + `\nکد پیگیری بانکی: ${authorityFromUrl}`);
      }
      addLog({ type: 'response', endpoint: 'Home/SabtNobat', ok: true });
    }
      setStep('verifying');
      addLog({ type: 'request', method: 'POST', endpoint: 'pay/Home/Verify', body: { amount, authority: authorityFromUrl } });
      const verifyRes = await payApi.post('/Home/Verify', { amount, authority: authorityFromUrl });
      addLog({ type: 'response', endpoint: 'pay/Home/Verify', ok: true, data: verifyRes?.data });

      const doctorFullName = parsedDesc?.['Doctor'] || `${localStorage.getItem('doctor_famil') || ''} ${localStorage.getItem('doctor_name') || ''}`.trim();
      const doctorFamil = doctorFullName.split(' ')[0] || '';
      const doctorName = doctorFullName.split(' ').slice(1).join(' ') || '';

      const inv = {
        CategoryName: categoryName,
        doctorName,
        doctorFamil,
        appointmentDate: dateJalali,
        appointmentTime: timeSelected,
        patientName: parsedDesc?.['Patient Name'] || ((user && user[0]) ? `${user[0].Fname} ${user[0].Lname}` : ''),
        paymentAmount: amount,
        paymentTime: sabtdate,
        authority: authorityFromUrl,
        serviceDoctorId: parsedDesc?.['Service Doctor ID'] || service?.ID,
        doctorId: parsedDesc?.['Doctor ID'] || doctorId,
        patientId,
        appointmentNumber,
      };

      setInvoiceData(inv);
      try {
        localStorage.setItem('isPaymentSuccessful', 'true');
        localStorage.setItem('authority', authorityFromUrl);
        localStorage.setItem('invoiceData', JSON.stringify(inv));
      } catch (_) {}

      setStep('receipt');
    } catch (e) {
      setError(e?.message || 'خطا در اجرای فرایند پرداخت');
      setStep('error');
    }
  }, [OID, addLog, authorityFromUrl, descParam, fetchDoctorService, fetchUserProfile, navigate, statusFromUrl, toHHMMSS, key]);

  useEffect(() => {
    isMountedRef.current = true;
    runFlow();
    return () => {
      isMountedRef.current = false;
    };
  }, [runFlow]);

  const handlePrint = () => {
    if (!invoiceData) return;
    const printContent = document.createElement('div');
    if(serviceCategoryId==='48'){
printContent.innerHTML = `
      <div dir="rtl" style="padding: 20px; font-family: 'Tahoma', sans-serif;">
        <h2 style="text-align: center; margin-bottom: 20px;">فاکتور پرداخت</h2>
        <div style="margin-bottom: 20px;">
          <p><strong>نوبت انتخابی:</strong> ${invoiceData.CategoryName || 'نامشخص'}</p>
          <p><strong>نام مراجعه‌کننده:</strong> ${invoiceData.patientName || 'نامشخص'}</p>
          <p><strong>مبلغ پرداختی:</strong> ${invoiceData.paymentAmount ? `${invoiceData.paymentAmount} ریال` : 'نامشخص'}</p>
          <p><strong>زمان پرداخت:</strong> ${moment().format('HH:mm')}</p>
          <p><strong>شماره تراکنش:</strong> <span style="direction:ltr; unicode-bidi:bidi-override; word-break:break-all; overflow-wrap:anywhere; display:inline-block; max-width:100%; vertical-align:bottom;">${authorityFromUrl || 'نامشخص'}</span></p>
          <p><strong>وضعیت:</strong> موفق</p>
        </div>
        <div style="text-align: center; margin-top: 30px; font-size: 12px;">
          <p>این فاکتور به صورت خودکار صادر شده و نیاز به مهر و امضا ندارد.</p>
        </div>
      </div>
    `;
    }else{
    printContent.innerHTML = `
      <div dir="rtl" style="padding: 20px; font-family: 'Tahoma', sans-serif;">
        <h2 style="text-align: center; margin-bottom: 20px;">فاکتور پرداخت</h2>
        <div style="margin-bottom: 20px;">
          <p><strong>نوبت انتخابی:</strong> ${invoiceData.CategoryName || 'نامشخص'}</p>
          <p><strong>نام پزشک:</strong> ${invoiceData.doctorName && invoiceData.doctorFamil ? `${invoiceData.doctorName}& ${invoiceData.doctorFamil}` : 'نامشخص'}</p>
          <p><strong>تاریخ نوبت:</strong> ${convertToShamsi(invoiceData.appointmentDate)}</p>
          <p><strong>زمان نوبت:</strong> ${formatTime(invoiceData.appointmentTime)}</p>
          <p><strong>نام مراجعه‌کننده:</strong> ${invoiceData.patientName || 'نامشخص'}</p>
          <p><strong>مبلغ پرداختی:</strong> ${invoiceData.paymentAmount ? `${invoiceData.paymentAmount} ریال` : 'نامشخص'}</p>
          <p><strong>زمان پرداخت:</strong> ${moment().format('HH:mm')}</p>
          <p><strong>شماره تراکنش:</strong> <span style="direction:ltr; unicode-bidi:bidi-override; word-break:break-all; overflow-wrap:anywhere; display:inline-block; max-width:100%; vertical-align:bottom;">${authorityFromUrl || 'نامشخص'}</span></p>
          <p><strong>وضعیت:</strong> موفق</p>
        </div>
        <div style="text-align: center; margin-top: 30px; font-size: 12px;">
          <p>این فاکتور به صورت خودکار صادر شده و نیاز به مهر و امضا ندارد.</p>
        </div>
      </div>
    `;
    }
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  const authority = useMemo(() => localStorage.getItem('authority') || authorityFromUrl, [authorityFromUrl]);

  const debugInfo = useMemo(() => {
    return {
      url: typeof window !== 'undefined' ? window.location.href : null,
      status: statusFromUrl || null,
      authority: authorityFromUrl || authority || null,
      desc: descParam || null,
      sabtNobatUrlRuntime: sabtNobatUrl || (typeof window !== 'undefined' ? localStorage.getItem('lastSabtNobatUrl') : null) || null,
      logs: logs,
      invoiceData: invoiceData,
    };
  }, [statusFromUrl, authorityFromUrl, authority, descParam, sabtNobatUrl, logs, invoiceData]);

  const debugText = useMemo(() => {
    try {
      return JSON.stringify(debugInfo, null, 2);
    } catch (_) {
      return '';
    }
  }, [debugInfo]);

  return (
    <div className="container mt-5">
      <style>
        {`
          @media print {
            body * { visibility: hidden !important; }
            #print-invoice, #print-invoice * { visibility: visible !important; }
            #print-invoice { position: absolute; left: 0; top: 0; width: 100vw; background: #fff !important; color: #000 !important; box-shadow: none !important; padding: 32px !important; font-family: Tahoma, Arial, sans-serif !important; }
            #print-invoice h3 { text-align: center; margin-bottom: 24px; font-size: 24px; }
            #print-invoice p { font-size: 16px; margin: 8px 0; }
            #print-invoice .d-flex, #print-invoice button { display: none !important; }
          }
          .authority-value { direction: ltr; unicode-bidi: bidi-override; word-break: break-all; overflow-wrap: anywhere; display: inline-block; max-width: 100%; vertical-align: bottom; }
          .confirm-btn { background-color: #0db2ba !important; border-color: #0db2ba !important; }
          .confirm-btn:hover { background-color: #0a9ba2 !important; border-color: #0a9ba2 !important; }
        `}
      </style>

      {step !== 'receipt' && step !== 'error' && (
        <div className="text-center mb-4">
          <div className="d-flex justify-content-center align-items-center gap-2">
            <Spinner animation="border" role="status" />
            <span>
              {step === 'init' && 'در حال آماده‌سازی...'}
              {step === 'reserving' && 'در حال ثبت نوبت...'}
              {step === 'verifying' && 'در حال تأیید پرداخت...'}
            </span>
          </div>
        </div>
      )}

      {step === 'error' && (
        <div className="alert alert-danger" role="alert">
          {error || 'خطای ناشناخته'}
        </div>
      )}

      {step === 'receipt' && invoiceData && (
        <div className="row mb-5 justify-content-center">
          <div className="col-md-6 doc_col pe-2">
            <div id="print-invoice" className="card p-3 shadow rounded-3 h-100">
              <h3 className="text-center">فاکتور پرداخت</h3>
              {serviceCategoryId==='48' &&(
                <div className="mt-4 text-center">
                <p><strong>نوبت انتخابی شما:</strong> {invoiceData.CategoryName || 'نامشخص'}</p>
                <p><strong>نام مراجعه‌کننده:</strong> {invoiceData.patientName || 'نامشخص'}</p>
                <p><strong>مبلغ پرداختی:</strong> {invoiceData.paymentAmount ? `${formatNumberWithPersianSeparators(invoiceData.paymentAmount)} ریال` : 'نامشخص'}</p>
                <p><strong>زمان پرداخت:</strong> {moment().format('HH:mm')}</p>
                <p>
                  <strong>شماره تراکنش (Authority):</strong>{' '}
                  <span className="authority-value">{authority || 'نامشخص'}</span>
                </p>
                <p><strong>وضعیت:</strong> موفق</p>
              </div>
              )}
               {serviceCategoryId!=='48' &&(
              <div className="mt-4 text-center">
                <p><strong>نوبت انتخابی شما:</strong> {invoiceData.CategoryName || 'نامشخص'}</p>
                
                <p><strong>نام پزشک:</strong> {serviceCategoryId === '1' ? 'بینایی سنج' : (invoiceData.doctorName && invoiceData.doctorFamil ? `${invoiceData.doctorName} ${invoiceData.doctorFamil}` : 'نامشخص')}</p>
                <p><strong>تاریخ نوبت:</strong> {convertToShamsi(invoiceData.appointmentDate)}</p>
                <p><strong>زمان نوبت:</strong> {formatTime(invoiceData.appointmentTime)}</p>
                <p><strong>نام مراجعه‌کننده:</strong> {invoiceData.patientName || 'نامشخص'}</p>
                <p><strong>مبلغ پرداختی:</strong> {invoiceData.paymentAmount ? `${formatNumberWithPersianSeparators(invoiceData.paymentAmount)} ریال` : 'نامشخص'}</p>
                <p><strong>زمان پرداخت:</strong> {moment().format('HH:mm')}</p>
                <p>
                  <strong>شماره تراکنش (Authority):</strong>{' '}
                  <span className="authority-value">{authority || 'نامشخص'}</span>
                </p>
                <p><strong>وضعیت:</strong> موفق</p>
              </div>
               )}
              <div className="d-flex gap-2 mt-4 justify-content-center">
                <Button variant="danger" onClick={handlePrint}>پرینت</Button>
                {serviceCategoryId === '48' ? (
                  <Button variant="primary" className="confirm-btn" onClick={() => navigate('/UploadFiles')}>بارگذاری مدارک</Button>
                ) : (
                  <Button variant="primary" className="confirm-btn" onClick={() => navigate('/history')}>گزارش نوبت</Button>
                )}
                
              </div>
            </div>
          </div>
          <div className="col-md-6 ps-2">
            <div className="card p-3 shadow rounded-3 h-100 text-center">
              <img  src={'/Img/printer.png'} 
              alt="wallet"
              className="w-100 h-100"
               style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentDebugFlow;


